<template>
  <div class="bar-content user">
    <Nav :show="false" />
    <div class="user-container">
      <ul class="navigation">
        <li v-for="route in routes" :key="route.name">
          <router-link :to="route.route">
            <span :class="{ active: route.name == currentPathName }">{{ route.value }}</span>
          </router-link>
        </li>
      </ul>
      <div class="route">
        <router-view></router-view>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Nav from '../components/comm/Nav';
import Footer from '../components/comm/Footer';
export default {
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      currentPathName: this.$route.name,
      routes: [
        {
          name: 'order',
          route: '/user/order',
          value: 'My Orders',
        },
        {
          name: 'profile',
          route: '/user/profile',
          value: 'Profile information',
        },
      ],
    };
  },
  methods: {
    goFormBox() {
      this.$router.push('/');
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.currentPathName = to.name;
    next();
  },
};
</script>

<style lang="less" scoped>
@import '../assets/css/main.less';
@import '../assets/fonts/font.less';
.user {
  background-color: @app-bg-color;
  min-height: 100%;
  .user-container {
    width: 1164px;
    margin: 57px auto 0;
    overflow: hidden;
    padding-bottom: 57px;
    .navigation {
      width: 220px;
      float: left;
      height: 100%;
      li {
        .font-regular;
        padding: 0 14px 50px;
        font-size: 18px;
        font-weight: 400;
        line-height: 22px;
        a {
          color: @app-body-color;
        }
        .active {
          color: @app-color;
        }
      }
    }
    .route {
      float: left;
      width: 944px;
      background-color: #fff;
      min-height: 614px;
      box-shadow: 0px 2px 8px 0px rgba(207, 207, 207, 0.2);
    }
  }
}
</style>
